import { Input, Radio, Select } from '@seiue/ui'
import React from 'react'
import styled from 'styled-components'
import { SelectTypeEnum } from './types'

/**
 * 单选|多选 - 样式设置
 *
 * @param param - 参数
 * @param param.selectType - 样式类型
 * @param param.onChange - 选中状态变化时的回调
 * @returns React.ReactNode
 */
export const OptionStyleSetting: React.FC<{
  selectType: SelectTypeEnum
  onChange: (param: object) => void
}> = ({ selectType, onChange }) => {
  return (
    <Wrapper>
      <div>
        <Radio
          checked={selectType === SelectTypeEnum.Checked}
          onChange={(e) => {
            if (!e.target.checked) return
            onChange({ selectType: SelectTypeEnum.Checked })
          }}
        >
          勾选
        </Radio>
        <Radio
          style={{ marginLeft: '24px' }}
          checked={selectType === SelectTypeEnum.DropDown}
          onChange={(e) => {
            if (!e.target.checked) return
            onChange({ selectType: SelectTypeEnum.DropDown })
          }}
        >
          下拉
        </Radio>
      </div>
      <StyleShowwrapper>
        <div>
          <Title>勾选</Title>
          <RadioWrapper>
            <Radio disabled>
              <Input disabled />
            </Radio>
            <Radio disabled>
              <Input disabled />
            </Radio>
          </RadioWrapper>
        </div>
        <SelectWrapper>
          <Title>下拉</Title>
          <Select disabled />
        </SelectWrapper>
      </StyleShowwrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div``

const StyleShowwrapper = styled.div`
  width: 100%;
  height: 112px;
  margin-top: 13px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.border.greyNormal};
`

const RadioWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 8px;
  .ant-input {
    width: 102px;
    height: 16px;
    border: none;
    border-radius: 0;
    background-color: ${(props) => props.theme.background._3};
  }
  .ant-radio {
    padding-bottom: 1px;
  }
  .ant-radio-wrapper-disabled {
    margin-right: 4px;
  }
  .ant-radio-inner {
    width: 12px;
    height: 12px;
  }
`

const Title = styled.div`
  margin-bottom: 4px;
  font-size: 12px;
  font-weight: 400;
  color: ${(props) => props.theme.text._3};
`

const SelectWrapper = styled.div`
  &&& {
    .ant-select-selector {
      width: 256px;
      height: 16px;
      border: none;
      border-radius: 0;
      background-color: ${(props) => props.theme.background._3};
    }
    .ant-select-selector::after {
      font-size: 6px;
    }
  }
`
